export class World {
  enabled = true;
  start_day = 0;
  start_month = 0;
  end_day = 0;
  end_month = 0;
  regions: { [regionId: string]: boolean } = {};
  managerName = "";
  seasonalVariant = "";
  youtube: string[] | null = null;
}
